import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useImperativeHandle,
  useRef,
  useState
} from 'react'

import { Botao, FormUnform, ModalBase, FormRef } from 'src/componentes'
import { EditorUnform } from 'src/componentes/unform/editor'
import { mensagemPadrao } from 'src/dados-estaticos'
import { ContainerBotoes } from 'src/paginas/ipgs/turmas/styles'
import { Api } from 'src/servicos'
import * as Yup from 'yup'

import { ModalCorpo } from './styles'
import { ModalEditarTextoApoioProps, ModalEditarTextoApoioRef } from './tipos'

const Componente: ForwardRefRenderFunction<
  ModalEditarTextoApoioRef,
  ModalEditarTextoApoioProps
> = ({ backdrop, aberta, acaoSucesso }, ref) => {
  const [aberto, definirAberto] = useState(aberta)
  const [pronto, definirPronto] = useState(false)
  const [carregando, definirCarregando] = useState(false)
  const [topicoId, definirTopicoId] = useState<string>(null)
  const [, definirComentariosBloqueados] = useState(false)
  const formRef = useRef<FormRef>()

  const abrir = topicoId => {
    definirTopicoId(topicoId)
    definirAberto(true)
    definirPronto(true)
  }

  const fechar = () => {
    definirTopicoId(null)
    definirPronto(false)
    definirAberto(false)
  }

  const acaoSucessoForm = async (payload: { textoApoio: string }) => {
    try {
      definirCarregando(true)

      await Api.EditarTextoApoio(topicoId, { textoApoio: payload.textoApoio })

      await acaoSucesso()
      definirComentariosBloqueados(false)
      fechar()
    } finally {
      definirCarregando(false)
    }
  }

  useImperativeHandle<ModalEditarTextoApoioRef, ModalEditarTextoApoioRef>(
    ref,
    () => ({
      fechar,
      abrir
    })
  )

  return (
    <ModalBase aberta={aberto} backdrop={backdrop}>
      <ModalCorpo>
        {pronto && (
          <FormUnform
            ref={formRef}
            acaoSucesso={acaoSucessoForm}
            schema={Yup.object().shape({
              textoApoio: Yup.string().required(mensagemPadrao)
            })}
          >
            <EditorUnform
              name="textoApoio"
              id="textoApoio"
              label="Texto de apoio"
            />
            <ContainerBotoes>
              <Botao
                type="button"
                texto="Cancelar"
                tema="Secundario"
                onClick={() => {
                  fechar()
                }}
                disabled={carregando}
              />
              <Botao
                type="button"
                id="btn-salvar"
                texto="Salvar"
                carregando={carregando}
                onClick={() => formRef?.current?.submitForm()}
              />
            </ContainerBotoes>
          </FormUnform>
        )}
      </ModalCorpo>
    </ModalBase>
  )
}

export const ModalEditarTextoApoio = forwardRef(Componente)
